module.exports = __webpack_public_path__ + "static/media/up-arrow.9ba86345.svg";